import React, { useState, useEffect } from 'react';
import '../styles/sculptd-theme.css';
import { Home, Dumbbell, Users, User, Award, Settings, Search, Plus, ChevronDown } from 'lucide-react';

// import { HomeDashboardPanel } from '../components/exercise-app/HomeDashboardPanel';
// import { OnboardingPanel } from '../components/exercise-app/OnboardingPanel';
import WorkoutPlayerPanel from '../components/exercise-app/WorkoutPlayerPanel';
import ExerciseLibraryPanel from '../components/exercise-app/ExerciseLibraryPanel';
import { WorkoutRecordingPanel } from '../components/exercise-app/WorkoutRecordingPanel';
import { CommunityPanel } from '../components/exercise-app/CommunityPanel';
import SocialMediaPanel from '../components/exercise-app/SocialMediaPanel';
import HealthDataPanel from '../components/exercise-app/HealthDataPanel';
import { PhotoProgressPanel } from '../components/exercise-app/PhotoProgressPanel';
// import { MotivationalPanel } from '../components/exercise-app/MotivationalPanel';
import { SomaChatPanel } from '../components/exercise-app/SomaChatPanel';
import GamificationPanel from '../components/exercise-app/GamificationPanel';
import AdminDashboardPanel from '../components/exercise-app/AdminDashboardPanel';
import { DeviceIntegrationPanel } from '../components/exercise-app/DeviceIntegrationPanel';
import { WearableVerificationPlugin } from '../components/exercise-app/WearableVerificationPlugin';
import { RecoveryVerificationPlugin } from '../components/exercise-app/RecoveryVerificationPlugin';
import WeightManagementPanel from '../components/exercise-app/WeightManagementPanel';
import StorePanel from '../components/exercise-app/StorePanel';
import CalendarSchedulePanel from '../components/exercise-app/CalendarSchedulePanel';
import ProgressRingsPanel from '../components/exercise-app/ProgressRingsPanel';
import WeeklyAnalyticsPanel from '../components/exercise-app/WeeklyAnalyticsPanel';
import FoodScanPanel from '../components/exercise-app/FoodScanPanel';
import MealPlanningPanel from '../components/exercise-app/MealPlanningPanel';
import FoodEntry from '../components/exercise-app/FoodEntry';

const FitnessMobile: React.FC = () => {
  const [activeComponent, setActiveComponent] = useState<string>('workout-player');
  const [showSettingsDropdown, setShowSettingsDropdown] = useState<boolean>(false);

  useEffect(() => {
    const handleNavigateToSchedule = () => {
      setActiveComponent('calendar-schedule');
    };

    const handleNavigateToComponent = (event: CustomEvent) => {
      const { componentId } = event.detail;
      setActiveComponent(componentId);
    };

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.settings-dropdown')) {
        setShowSettingsDropdown(false);
      }
    };

    window.addEventListener('navigate-to-schedule', handleNavigateToSchedule);
    window.addEventListener('navigate-to-component', handleNavigateToComponent as EventListener);
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      window.removeEventListener('navigate-to-schedule', handleNavigateToSchedule);
      window.removeEventListener('navigate-to-component', handleNavigateToComponent as EventListener);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const bottomNavComponents = [
    // { id: 'dashboard', name: 'Home', component: HomeDashboardPanel, icon: Home },
    { id: 'workout-player', name: 'Workout', component: WorkoutPlayerPanel, icon: Dumbbell },
    { id: 'exercise-library', name: 'Exercises', component: ExerciseLibraryPanel, icon: Search },
    { id: 'store', name: 'Store', component: StorePanel, icon: Plus },
    { id: 'community', name: 'Community', component: CommunityPanel, icon: Users },
  ];

  const mainComponents = [
    // { id: 'dashboard', name: 'Home Dashboard', component: HomeDashboardPanel },
    { id: 'workout-player', name: 'Workout Player', component: WorkoutPlayerPanel },
    { id: 'exercise-library', name: 'Exercise Library', component: ExerciseLibraryPanel },
    { id: 'workout-recording', name: 'Workout Recording', component: WorkoutRecordingPanel },
    { id: 'calendar-schedule', name: 'Schedule', component: CalendarSchedulePanel },
    { id: 'progress-rings', name: 'Progress', component: ProgressRingsPanel },
    { id: 'weekly-analytics', name: 'Analytics', component: WeeklyAnalyticsPanel },
    { id: 'food-scan', name: 'Food Scanner', component: FoodScanPanel },
    { id: 'meal-planning', name: 'Meal Planning', component: MealPlanningPanel },
    { id: 'food-entry', name: 'Food Entry', component: FoodEntry },
    { id: 'community', name: 'Community', component: CommunityPanel },
    { id: 'social-media', name: 'Social Media', component: SocialMediaPanel },
    { id: 'health-data', name: 'Health Data', component: HealthDataPanel },
    { id: 'weight-management', name: 'Weight Management', component: WeightManagementPanel },
    { id: 'photo-progress', name: 'Photo Progress', component: PhotoProgressPanel },
    // { id: 'motivational', name: 'Motivational', component: MotivationalPanel },
    { id: 'soma-chat', name: 'Coach Chat', component: SomaChatPanel },
    { id: 'gamification', name: 'Awards', component: GamificationPanel },
    { id: 'store', name: 'Store', component: StorePanel },
  ];

  const settingsComponents = [
    { id: 'admin-dashboard', name: 'Admin Dashboard', component: AdminDashboardPanel },
    { id: 'device-integration', name: 'Device Integration', component: DeviceIntegrationPanel },
    { id: 'wearable-verification', name: 'Wearable Verification', component: WearableVerificationPlugin },
    { id: 'recovery-verification', name: 'Recovery Verification', component: RecoveryVerificationPlugin },
  ];

  const allComponents = [...mainComponents, ...settingsComponents]; // { id: 'onboarding', name: 'Onboarding', component: OnboardingPanel }

  const renderActiveComponent = () => {
    const activeComp = allComponents.find(comp => comp.id === activeComponent);
    if (!activeComp) return null;

    const Component = activeComp.component;
    
    if (activeComponent === 'soma-chat') {
      const SomaChatComponent = Component as React.ComponentType<any>;
      return (
        <div className="h-full">
          <SomaChatComponent 
            userId="demo-user"
            sessionId="demo-session"
            userProfile={{ name: 'Toshika', currentProgram: 'Weight Loss & Energy' }}
            privacySettings={{ 
              encryptionLevel: 'enhanced',
              dataRetention: 30,
              auditLogging: true,
              allowMedicalSharing: false
            }}
            demoMode={true}
          />
        </div>
      );
    }
    
    return (
      <div className="h-full">
        <Component />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ 
      maxWidth: '428px', 
      margin: '0 auto',
      background: 'var(--color-background)' 
    }}>
      <div className="bg-white shadow-lg border-b sticky top-0 z-30" style={{ boxShadow: 'var(--shadow-lg)' }}>
        <div className="px-4 py-4">
          <div className="flex items-center justify-between">
            <img 
              src="/assets/sculptd-logo.png" 
              alt="SCULPTD" 
              className="h-8 w-auto"
              style={{ 
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
              }}
            />
            <div className="flex items-center space-x-3">
              {/* <button 
                onClick={() => setActiveComponent('onboarding')}
                className="p-3 rounded-lg transition-all duration-200" 
                style={{ 
                  background: 'var(--gradient-card-bg)',
                  boxShadow: 'var(--shadow-sm)',
                  minHeight: '44px',
                  minWidth: '44px'
                }}
              >
                <Plus className="h-5 w-5" style={{ color: 'var(--color-text-muted)' }} />
              </button> */}
              <div className="relative settings-dropdown">
                <button 
                  onClick={() => setShowSettingsDropdown(!showSettingsDropdown)}
                  className="p-3 rounded-lg transition-all duration-200 flex items-center space-x-1" 
                  style={{ 
                    background: showSettingsDropdown ? 'var(--gradient-primary)' : 'var(--gradient-card-bg)',
                    boxShadow: 'var(--shadow-sm)',
                    minHeight: '44px',
                    minWidth: '44px'
                  }}
                >
                  <Settings className="h-5 w-5" style={{ 
                    color: showSettingsDropdown ? 'var(--color-white)' : 'var(--color-text-muted)' 
                  }} />
                  <ChevronDown className="h-3 w-3" style={{ 
                    color: showSettingsDropdown ? 'var(--color-white)' : 'var(--color-text-muted)',
                    transform: showSettingsDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }} />
                </button>
                
                {showSettingsDropdown && (
                  <div 
                    className="absolute right-0 top-full mt-2 w-64 rounded-lg shadow-lg z-50"
                    style={{
                      background: 'var(--gradient-card-bg)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      boxShadow: 'var(--shadow-lg)'
                    }}
                  >
                    <div className="p-2">
                      <div className="text-xs font-semibold mb-2 px-3 py-2" style={{ 
                        color: 'var(--color-text-muted)' 
                      }}>
                        System Tools
                      </div>
                      {settingsComponents.map((comp) => (
                        <button
                          key={comp.id}
                          onClick={() => {
                            setActiveComponent(comp.id);
                            setShowSettingsDropdown(false);
                          }}
                          className="w-full text-left px-3 py-2 rounded-lg transition-all duration-200 hover:scale-[1.02]"
                          style={{
                            background: activeComponent === comp.id 
                              ? 'var(--gradient-primary)' 
                              : 'transparent',
                            color: activeComponent === comp.id 
                              ? 'var(--color-white)' 
                              : 'var(--color-text)',
                            marginBottom: '2px'
                          }}
                          onMouseEnter={(e) => {
                            if (activeComponent !== comp.id) {
                              (e.target as HTMLElement).style.background = 'rgba(58, 175, 169, 0.1)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeComponent !== comp.id) {
                              (e.target as HTMLElement).style.background = 'transparent';
                            }
                          }}
                        >
                          {comp.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Horizontal Scrollable Tabs */}
      <div className="bg-white border-b border-gray-200 sticky top-16 z-20">
        <div 
          className="flex overflow-x-auto px-4 py-4 scrollbar-hide" 
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          {mainComponents.map((comp) => (
            <button
              key={comp.id}
              onClick={() => setActiveComponent(comp.id)}
              className="flex-shrink-0 px-6 py-3 mr-3 text-base font-semibold rounded-lg transition-all duration-300 whitespace-nowrap shadow-sm"
              style={{
                background: activeComponent === comp.id 
                  ? 'var(--gradient-primary)' 
                  : 'var(--gradient-card-bg)',
                color: activeComponent === comp.id 
                  ? 'var(--color-white)' 
                  : 'var(--color-text)',
                minHeight: '48px',
                boxShadow: activeComponent === comp.id 
                  ? 'var(--shadow-lg)' 
                  : 'var(--shadow-sm)',
                border: activeComponent === comp.id 
                  ? 'none' 
                  : '1px solid rgba(0,0,0,0.08)',
                textShadow: activeComponent === comp.id 
                  ? '0 1px 2px rgba(0,0,0,0.1)' 
                  : 'none'
              }}
              onMouseEnter={(e) => {
                if (activeComponent !== comp.id) {
                  (e.target as HTMLElement).style.transform = 'translateY(-1px)';
                  (e.target as HTMLElement).style.boxShadow = 'var(--shadow-md)';
                }
              }}
              onMouseLeave={(e) => {
                if (activeComponent !== comp.id) {
                  (e.target as HTMLElement).style.transform = 'translateY(0)';
                  (e.target as HTMLElement).style.boxShadow = 'var(--shadow-sm)';
                }
              }}
            >
              {comp.name}
            </button>
          ))}
        </div>
        <style>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>

      <div className="pb-20" style={{ minHeight: 'calc(100vh - 180px)' }}>
        <div className="px-4 py-6">
          {renderActiveComponent()}
        </div>
      </div>

      <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-[428px] bg-white border-t border-gray-200 z-40 shadow-lg">
        <div className="flex justify-around items-center py-2 px-2">
          {bottomNavComponents.map((comp) => {
            const Icon = comp.icon;
            const isActive = activeComponent === comp.id;
            return (
              <button
                key={comp.id}
                onClick={() => setActiveComponent(comp.id)}
                className="flex flex-col items-center justify-center py-2 px-3 min-w-0 flex-1 rounded-lg transition-all duration-200"
                style={{
                  background: isActive ? 'var(--color-primary)' : 'transparent',
                  color: isActive ? 'var(--color-white)' : 'var(--color-text-muted)',
                  minHeight: '44px'
                }}
              >
                <Icon 
                  className="h-6 w-6 mb-1" 
                  style={{
                    color: isActive ? 'var(--color-white)' : 'var(--color-text-muted)',
                  }}
                />
                <span 
                  className="text-xs font-medium truncate"
                  style={{
                    color: isActive ? 'var(--color-white)' : 'var(--color-text-muted)',
                  }}
                >
                  {comp.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FitnessMobile;
